// @flow

export const resources = (state: $ElementType<ReduxState, 'resources'> = []) => state;
